export default "__VITE_ASSET__DuEILC1B__"